import StitchFeaturePage from "../../components/sections/StitchFeaturePage";
import SectionLabel from "../../components/ui/SectionLabel";

const features = [
  { title: "Finance & Accounting", desc: "GST-compliant invoicing, P&L visibility, and Tally sync." },
  { title: "Inventory Management", desc: "Multi-location inventory, purchase orders, and barcode-enabled tracking." },
  { title: "HR & Payroll", desc: "Attendance, leave, salary, and PF/ESI compliance workflows." },
  { title: "Reports & Analytics", desc: "Real-time dashboards and custom reporting for the operating team and leadership." },
];

const ErpDevelopment = () => (
  <StitchFeaturePage
    label="SERVICE · ERP DEVELOPMENT"
    title="The central nervous"
    titleAccent="system of your business."
    subtitle="A custom ERP connecting finance, inventory, HR, sales, procurement, and production — built for how you actually operate."
    features={features}
    ctaLabel="BUILD YOUR ERP"
  >
    <div style={{ display: "grid", gap: 28 }}>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 18 }}>
        {[
          "Sales & CRM — Lead-to-cash pipeline, quotations, target tracking",
          "Purchase & Procurement — Vendor management, PO, approval workflows",
          "Manufacturing — BOM, production orders, quality checks",
          "Project Management — Task boards, milestones, time tracking",
          "Customer Portal — Order status, invoice downloads, support tickets",
        ].map((item) => (
          <div key={item} style={{ background: "#0E0E0E", border: "1px solid rgba(212,168,67,0.18)", borderRadius: 4, padding: 22, fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: "#F8F4EC", lineHeight: 1.75 }}>
            {item}
          </div>
        ))}
      </div>

      </div>
  </StitchFeaturePage>
);

export default ErpDevelopment;
